export const toTokenExpirationMs = (expiration) => {
  if (expiration === null || expiration === undefined || expiration === '') return Number.NaN;
  const numericExpiration = Number(expiration);
  return Number.isFinite(numericExpiration)
    ? numericExpiration < 1e12
      ? numericExpiration * 1000
      : numericExpiration
    : new Date(expiration).getTime();
};

export const isTokenExpirationValid = (expiration, now = Date.now()) => {
  const expirationMs = toTokenExpirationMs(expiration);
  return Number.isFinite(expirationMs) && now < expirationMs;
};
